import * as yup from 'yup';
export const updateMerchantAccountLockboxConfigSchema = yup.object({
    folderId: yup.string().optional().nullable(),
    folderName: yup.string().optional().nullable(),
    accessLevelId: yup.string().optional().nullable(),
    accessLevelName: yup.string().optional().nullable(),
    merchantAccountId: yup.number().integer().optional(),
    checkDisplayEnabled: yup.boolean().optional(),
    checkDownloadEnabled: yup.boolean().optional(),
    checkWritebackEnabled: yup.boolean().optional(),
    dailyPaymentsProcessedEmails: yup.array().of(yup.string().email().required()).optional(),
    batchSettlementEmails: yup.array().of(yup.string().email().required()).optional(),
    returnedCheckEmails: yup.array().of(yup.string().email().required()).optional(),
});
//# sourceMappingURL=merchantAccountLockboxConfig.js.map